//  https://m-app.charmdeer.com/services/biz/module_tp_hotel/find/groups/

import common from "@charmdeer/common";

import { http } from "@/utils/http";

export const getBrands = data => {
  return http.post("/biz/module_tp_hotel/find/groups", { data: data });
};

export const searchUniversalViaPost = async keyword => {
  // * @param {string[]} [query.categories] 分类
  // * * `moduleHomeStay`
  // * * `moduleRestaurant`
  // * * `moduleTpHotel`
  // * * `moduleVoucher`
  if (!keyword) {
    return {};
  }
  const categories = ["moduleTpHotel", "city"];
  categories.push("googleMapPolitical");
  const res = await http.post("biz/search/universalViaPost", {
    data: { keyword, limit: 5, categories, projectModuleTpHotel: true }
  });
  return res.resultsByCategory;
};

// https://hotel.charmdeer.com/services/biz/order/bi/query

export const getChannels = () => {
  return http.post("/biz/order/bi/query", {
    data: {
      criteria: {
        type: "tpHotel"
      },
      dimensions: ["channelRef"]
    }
  });
};

// /services/biz/ugc/post/vendor/notified?postRef-6125f0bf35f10b3b79ac8ca2

/**
 * 获取服务器信息
 * @returns
 */
export const getDeployment = () => {
  return http.get("/biz/util/deployment/ytripos");
};
/**
 * 获取服务器信息
 * @returns
 */
export const getHlDeployment = () => {
  return http.get("/biz/util/deployment/hotelux");
};

export const getChannelsByPostRef = async postRef => {
  const res = await http.get("biz/ugc/post/vendor/notified", {
    params: {
      postRef
    }
  });
  return res;
};

/**
 * 获取session中的值
 * @param {*} key
 * @returns
 */
export const getSessionItem = async key => {
  return await http.get("/biz/util/session/getItem", { params: { key } });
};

/**
 * 设置session中的值
 * @param {*} data
 * @returns
 */
export const setSessionItem = async (data = {}) => {
  return http.post("/biz/util/session/setItem", { data });
};

/**
 * 获取上一次使用的银行卡
 * @param types
 * @returns
 */

export const getPreviousCreditCard = async types => {
  const res = await http.get("biz/order/unmask/getPreviousCreditCard", {
    types
  });
  const cardInfo = res.creditCard || {};
  return cardInfo;
};
